import { Observable, throwError, timer } from 'rxjs';
import { catchError, concatMap, retryWhen } from 'rxjs/operators';

import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { FsDataDogRumService } from '@lib/data-dog-rum';

import { SN_API_URL } from '../providers/api-url.provider';

@Injectable()
export class SnExponentialRetryInterceptor implements HttpInterceptor {
  constructor(
    @Inject(SN_API_URL) private readonly _apiUrl: string,
    private readonly _dd: FsDataDogRumService,
  ) {}

  public intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(this._apiUrl) && !this._excludeRequests(req.url)) {
      return handler.handle(req).pipe(
        retryWhen((errors) =>
          errors.pipe(
            concatMap((error, count) => {
              if (count < 2 && (error.status === 0 || error.status === 502)) {
                return timer(1000 * (count + 1));
              }
              return throwError(error);
            }),
          ),
        ),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 0 || error.status === 502) {
            this._dd.addAction('network_request_failed_retries', error);
          }
          return throwError(error);
        }),
      );
    }
    return handler.handle(req);
  }

  private _excludeRequests(url: string): boolean {
    return ['/api/auth/jwt/obtain'].some((pattern) => url.includes(pattern));
  }
}
